module.exports = __webpack_public_path__ + "img/build1020.e4771610.png";